<template>
  <form
    method="POST"
    v-bind="{
      target: '_blank',
      ...(formAttrs ?? {}),
    }"
    :action="reverseFull({ name: 'prg:prg' })"
    @click="emit('click')"
  >
    <input
      type="hidden"
      name="csrfmiddlewaretoken"
      :value="context.csrf_token"
    >
    <input
      type="hidden"
      name="url"
      :value="encodedUrl"
    >
    <button
      v-bind="buttonAttrs"
      type="submit"
    >
      <slot />
    </button>
  </form>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useContextStore, useURLStore } from 'src/store'

type Attrs = { [k: string]: string }

const props = defineProps<{
  url: string
  formAttrs?: Attrs,
  buttonAttrs?: Attrs,
}>()

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()

const { context } = useContextStore()
const { reverseFull } = useURLStore()

const encodedUrl = ref(props.url)

onMounted(() => {
  if (process.env.IS_CLIENT) {
    encodedUrl.value = encodeURIComponent(props.url).replace(/%2F/g, '/')
  }
})
</script>
